import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {NumberFormat,DateThaiFormat,DateFormatJSON} from '../../Utils/Function';
import moment from 'moment';
import ThaiDatePicker from '../../Components/ThaiDatePicker';
import { createRoot } from 'react-dom/client';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../Assets/CSS/TALFC.css';

const PageAggregateList =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();

    const ref = useRef();
    //const [_Date,setDate] = useState(moment().add(-1,'day').toDate());
    const [_Date,setDate] = useState(moment().toDate());

    const [_StoreList,setStoreList] = useState([]);
    useEffect(() => {
        (async () => {
            //setValue("Date",moment().add(-1,'day').toDate());
            setValue("Date",moment().toDate());

            _LoadStoreList();
        })();

        return ()=>{ }
    }, []);
    const _LoadStoreList= async()=>{
        setStoreList([]);
        API({method : "get",url:"/Staff/Store/List"}).then(res=>{
                if (res.status !== 200) {
                    return;
                }

                if (!res.data.Status) {
                    return;
                }
                setStoreList(res.data.Data);
        }).catch(res => {
                return;
        });
    }
    
   
    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 25,
        orderMulti: true
    }
    
    const _ajax  = {
        'url': '/Report/Aggregate/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.StoreID = getValues('StoreID');
            const _D = moment(getValues('Date'));
            d.Date = _D.format("YYYY/MM/DD");
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
        </div>
    )
    const _column = [
       {data: "AggregateDate", name: "AggregateDate", autoWidth: true,render(data){
            return DateThaiFormat(data,false);
        }},
        { data: "StoreCode", name: "StoreCode", autoWidth: true },
        { data: "StoreName", name: "StoreName", autoWidth: true },
        { data: "IncomeAmount", name: "IncomeAmount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "ShareAmount", name: "ShareAmount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "TotalAmount", name: "TotalAmount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        {data: "Created", name: "Created", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        {
            data: "AggregateId", name: "AggregateId", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    const _UpdateTable =()=>{
        ref.current?.load();
    }
    const _PDFAggregate = async()=>{
        Swal.fire('Please wait')
        Swal.showLoading()
        const _D = moment(getValues('Date'));
        const _reqObj = {
            Date: DateFormatJSON(getValues('Date'),false)
        }
       API({method : 'post',url:'/Report/Aggregate/PDF',data:_reqObj,headers: { "Content-Type": "multipart/form-data" }}).then(res=>{        
            if (res.status !== 200) {
                Swal.close();
                return;
            }
            console.log(res.data);

            if (!res.data.Status) {
                Swal.fire({
                    icon: 'error',
                    title: res.data.Message
                });
                Swal.close();
                return;
            }
             var base64str = res.data.Data.PDF;
             var binary = atob(base64str.replace(/\s/g, ''));
             var len = binary.length;
             var buffer = new ArrayBuffer(len);
             var view = new Uint8Array(buffer);
             for (var i = 0; i < len; i++) {
                 view[i] = binary.charCodeAt(i);
             }
             var blob = new Blob( [view], { type: "application/pdf" });
             var url = URL.createObjectURL(blob);
             window.open(url, '_blank');
             Swal.close();
        }).catch(res => {
            Swal.close();
            return;
        });
    }
    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-4'>
                    <div className='col-lg-12'>
                    <div className='card'>
                            <div className='card-header'>
                                <h3 className='card-title'>สรุปยกยอด</h3>
                            </div>
                            <div className='card-body' style={{'minHeight':'300px'}}>
                                <div className="row mt-2 mb-2 justify-content-end">
                                    <div className='col-12 col-lg-2 mt-1'>
                                        <ThaiDatePicker className='form-control text-center' selected={_Date} onChange={(date) => { setDate(date);setValue('Date',date); setTimeout(()=>{ref.current.load();},200); }} selectsStart startDate={_Date} maxDate={moment().toDate()} />
                                    </div>
                                    <div className='col-12 col-lg-3 text-end'>
                                        <div className='input-group float-end'>
                                            <select className='form-control text-center' {...register("StoreID", { required: false })} defaultValue={0} onChange={(e)=>{setValue("StoreID",e.target.value); setTimeout(()=>{ref.current.load();},200);}} >
                                                <option value={''} selected>ทั้งหมด</option>
                                                {_StoreList.map((v,i)=>(
                                                    <option key={i} value={v.StoreID}>{v.StoreCode} | {v.StoreName}</option>
                                                ))}
                                            </select>
                                            <div className='btn btn-group btn-group-sm'>
                                                <button type="button" className='btn btn-primary btn-sm' onClick={()=>{_PDFAggregate();}}>เพิ่มใบสรุปยกยอด</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-12 table-responsive">
                                        <table id="TransactionTableView" className='table w-100' role='grid'>
                                            <thead>
                                                <tr>
                                                <th className="text-center textcenter">วันที่</th>
                                                <th className="text-center textcenter no-sort">รหัสร้านค้า</th>
                                                <th className="text-center textcenter no-sort">ชื่อร้านค้า</th>
                                                <th className="text-center textcenter">ยอดขาย</th>
                                                <th className="text-center textcenter">ส่วนแบ่ง</th>
                                                <th className="text-center textcenter">ยอดเงินสรุป</th>
                                                <th className="text-center textcenter">วันที่สร้าง</th>

                                                <th className="text-center no-sort"></th>
                                                </tr>
                                            </thead>
                                            <DataTable TableID={"TransactionTableView"} Column={_column} Configs={_configs} ref={ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
        </>
    )
}

export default React.memo(PageAggregateList)
